module.exports = __webpack_public_path__ + "img/smart_scale_power.95c8bd51.png";